import BulkActionsContainer from './BulkActionsContainer';

export default BulkActionsContainer;
